export abstract class SSNMaskingStrategy {
  abstract getMask(): string;
  abstract isHiddenInput(): boolean;
}

